import React from 'react'
import PropTypes from 'prop-types'
import { useFormContext, Controller } from 'react-hook-form'

import { InputWrapperDiv } from '../styles/Containers'
import { TextField } from '../styles/TextField'
import Label from './Label'

const getError = (id, errors) => {
  return id.split('.').reduce((o, i) => {
    const exists = o[i] !== undefined
    if (!exists) return {}
    return o[i]
  }, errors)
}

function FormattedInput({
  required = false,
  id,
  label,
  basis,
  handleFormatValue,
  disabled = false,
  tooltip = '',
  placeholder = '',
  inputProps,
  textFieldFormat = 'default'
}) {
  const { register, formState, control } = useFormContext()

  const errors = formState.errors
  const error = getError(id, errors)

  return (
    <InputWrapperDiv basis={basis}>
      <Controller
        id={id}
        name={id}
        control={control}
        render={({ field: { onChange, value } }) => (
          <TextField
            refs={{ ...register(id) }}
            onChange={e => {
              const value = handleFormatValue(e.target.value)
              onChange(value)
            }}
            value={value}
            variant="standard"
            label={<Label label={label} tooltip={tooltip} />}
            InputLabelProps={{
              shrink: true,
              required,
              focused: false
            }}
            InputProps={{
              disableUnderline: true,
              ...inputProps
            }}
            disabled={disabled}
            error={Object.keys(error).length > 0 && !!error}
            helperText={error?.message}
            FormHelperTextProps={{ role: 'alert' }}
            placeholder={placeholder}
            styleformat={textFieldFormat}
          />
        )}
      />
    </InputWrapperDiv>
  )
}

FormattedInput.propTypes = {
  id: PropTypes.string.isRequired,
  required: PropTypes.bool,
  label: PropTypes.string.isRequired,
  basis: PropTypes.string,
  handleFormatValue: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
  inputProps: PropTypes.object,
  placeholder: PropTypes.string,
  textFieldFormat: PropTypes.oneOf(['default', 'condensed'])
}

export default FormattedInput
